function incomeOrExpense(transaction) {
  return transaction.isIncome ? 'הכנסה' : 'הוצאה';
}

export default {
  incomeOrExpense,
};
